import type { TrpcFormattedErrorData } from '@/types/appRouter';

export type TradeLogicCapabilityErrorDetails = NonNullable<TrpcFormattedErrorData['tradeLogicCapabilityError']>;

type TradeLogicCapabilityErrorCarrier = {
    data?: Partial<TrpcFormattedErrorData> | null;
};

const isTradeLogicCapabilityErrorCarrier = (value: object): value is TradeLogicCapabilityErrorCarrier => {
    return 'data' in value;
};

export const getTradeLogicCapabilityError = (value: object | null | undefined): TradeLogicCapabilityErrorDetails | null => {
    if (!value || !isTradeLogicCapabilityErrorCarrier(value)) {
        return null;
    }

    return value.data?.tradeLogicCapabilityError ?? null;
};
